// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension="
// @generated from file analytics/v2/service.proto (package analytics.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage
} from '@bufbuild/protobuf'
import { Message, proto3, protoInt64, Timestamp } from '@bufbuild/protobuf'
import {
  CountData,
  EventType,
  Pagination,
  Product,
  RangeSummaryData,
  SummaryData,
  TopCodesData,
  TopDestinationsData,
  TopLinksData,
  TopPagesData,
  TopUTMCampaignsData,
  TopUTMReferrersData,
  TopUTMTermsData
} from './analytics_pb'

/**
 * Healthcheck
 *
 * @generated from message analytics.v2.HealthCheckRequest
 */
export class HealthCheckRequest extends Message<HealthCheckRequest> {
  constructor(data?: PartialMessage<HealthCheckRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.HealthCheckRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HealthCheckRequest {
    return new HealthCheckRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HealthCheckRequest {
    return new HealthCheckRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): HealthCheckRequest {
    return new HealthCheckRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: HealthCheckRequest | PlainMessage<HealthCheckRequest> | undefined,
    b: HealthCheckRequest | PlainMessage<HealthCheckRequest> | undefined
  ): boolean {
    return proto3.util.equals(HealthCheckRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.HealthCheckResponse
 */
export class HealthCheckResponse extends Message<HealthCheckResponse> {
  constructor(data?: PartialMessage<HealthCheckResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.HealthCheckResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HealthCheckResponse {
    return new HealthCheckResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HealthCheckResponse {
    return new HealthCheckResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): HealthCheckResponse {
    return new HealthCheckResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: HealthCheckResponse | PlainMessage<HealthCheckResponse> | undefined,
    b: HealthCheckResponse | PlainMessage<HealthCheckResponse> | undefined
  ): boolean {
    return proto3.util.equals(HealthCheckResponse, a, b)
  }
}

/**
 * Range summary
 *
 * @generated from message analytics.v2.RangeSummaryRequest
 */
export class RangeSummaryRequest extends Message<RangeSummaryRequest> {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product = Product.UNSPECIFIED

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[] = []

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 5;
   */
  timezone = ''

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets = false

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[] = []

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[] = []

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[] = []

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[] = []

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[] = []

  constructor(data?: PartialMessage<RangeSummaryRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.RangeSummaryRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'product', kind: 'enum', T: proto3.getEnumType(Product) },
    { no: 2, name: 'event_type', kind: 'enum', T: proto3.getEnumType(EventType), repeated: true },
    { no: 3, name: 'start_date', kind: 'message', T: Timestamp },
    { no: 4, name: 'end_date', kind: 'message', T: Timestamp },
    { no: 5, name: 'timezone', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'all_assets', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: 'team_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: 'asset_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: 'page_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'directory_id', kind: 'scalar', T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 11, name: 'tag_name', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RangeSummaryRequest {
    return new RangeSummaryRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RangeSummaryRequest {
    return new RangeSummaryRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): RangeSummaryRequest {
    return new RangeSummaryRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: RangeSummaryRequest | PlainMessage<RangeSummaryRequest> | undefined,
    b: RangeSummaryRequest | PlainMessage<RangeSummaryRequest> | undefined
  ): boolean {
    return proto3.util.equals(RangeSummaryRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.RangeSummaryResponse
 */
export class RangeSummaryResponse extends Message<RangeSummaryResponse> {
  /**
   * @generated from field: analytics.v2.RangeSummaryData data = 1;
   */
  data?: RangeSummaryData

  constructor(data?: PartialMessage<RangeSummaryResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.RangeSummaryResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'data', kind: 'message', T: RangeSummaryData }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RangeSummaryResponse {
    return new RangeSummaryResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RangeSummaryResponse {
    return new RangeSummaryResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): RangeSummaryResponse {
    return new RangeSummaryResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: RangeSummaryResponse | PlainMessage<RangeSummaryResponse> | undefined,
    b: RangeSummaryResponse | PlainMessage<RangeSummaryResponse> | undefined
  ): boolean {
    return proto3.util.equals(RangeSummaryResponse, a, b)
  }
}

/**
 * Summary
 *
 * @generated from message analytics.v2.SummaryRequest
 */
export class SummaryRequest extends Message<SummaryRequest> {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product = Product.UNSPECIFIED

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[] = []

  /**
   * @generated from field: string timezone = 3;
   */
  timezone = ''

  /**
   * @generated from field: bool all_assets = 4;
   */
  allAssets = false

  /**
   * @generated from field: repeated string team_id = 5;
   */
  teamId: string[] = []

  /**
   * @generated from field: repeated string asset_id = 6;
   */
  assetId: string[] = []

  /**
   * @generated from field: repeated string page_id = 7;
   */
  pageId: string[] = []

  /**
   * @generated from field: repeated int32 directory_id = 8;
   */
  directoryId: number[] = []

  /**
   * @generated from field: repeated string tag_name = 9;
   */
  tagName: string[] = []

  constructor(data?: PartialMessage<SummaryRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.SummaryRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'product', kind: 'enum', T: proto3.getEnumType(Product) },
    { no: 2, name: 'event_type', kind: 'enum', T: proto3.getEnumType(EventType), repeated: true },
    { no: 3, name: 'timezone', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'all_assets', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: 'team_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: 'asset_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: 'page_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: 'directory_id', kind: 'scalar', T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 9, name: 'tag_name', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SummaryRequest {
    return new SummaryRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SummaryRequest {
    return new SummaryRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SummaryRequest {
    return new SummaryRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: SummaryRequest | PlainMessage<SummaryRequest> | undefined,
    b: SummaryRequest | PlainMessage<SummaryRequest> | undefined
  ): boolean {
    return proto3.util.equals(SummaryRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.SummaryResponse
 */
export class SummaryResponse extends Message<SummaryResponse> {
  /**
   * @generated from field: analytics.v2.SummaryData data = 1;
   */
  data?: SummaryData

  constructor(data?: PartialMessage<SummaryResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.SummaryResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'data', kind: 'message', T: SummaryData }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SummaryResponse {
    return new SummaryResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SummaryResponse {
    return new SummaryResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SummaryResponse {
    return new SummaryResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: SummaryResponse | PlainMessage<SummaryResponse> | undefined,
    b: SummaryResponse | PlainMessage<SummaryResponse> | undefined
  ): boolean {
    return proto3.util.equals(SummaryResponse, a, b)
  }
}

/**
 * Count
 *
 * @generated from message analytics.v2.CountRequest
 */
export class CountRequest extends Message<CountRequest> {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product = Product.UNSPECIFIED

  /**
   * @generated from field: repeated string asset_id = 2;
   */
  assetId: string[] = []

  /**
   * @generated from field: repeated string page_id = 3;
   */
  pageId: string[] = []

  /**
   * @generated from field: bool all_assets = 4;
   */
  allAssets = false

  constructor(data?: PartialMessage<CountRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.CountRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'product', kind: 'enum', T: proto3.getEnumType(Product) },
    { no: 2, name: 'asset_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: 'page_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: 'all_assets', kind: 'scalar', T: 8 /* ScalarType.BOOL */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountRequest {
    return new CountRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountRequest {
    return new CountRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountRequest {
    return new CountRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: CountRequest | PlainMessage<CountRequest> | undefined,
    b: CountRequest | PlainMessage<CountRequest> | undefined
  ): boolean {
    return proto3.util.equals(CountRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.CountResponse
 */
export class CountResponse extends Message<CountResponse> {
  /**
   * @generated from field: analytics.v2.CountData data = 1;
   */
  data?: CountData

  constructor(data?: PartialMessage<CountResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.CountResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'data', kind: 'message', T: CountData }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountResponse {
    return new CountResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountResponse {
    return new CountResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountResponse {
    return new CountResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: CountResponse | PlainMessage<CountResponse> | undefined,
    b: CountResponse | PlainMessage<CountResponse> | undefined
  ): boolean {
    return proto3.util.equals(CountResponse, a, b)
  }
}

/**
 * Top
 *
 * @generated from message analytics.v2.TopRequest
 */
export class TopRequest extends Message<TopRequest> {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product = Product.UNSPECIFIED

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[] = []

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 5;
   */
  timezone = ''

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets = false

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[] = []

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[] = []

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[] = []

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[] = []

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[] = []

  /**
   * @generated from field: int64 page_size = 12;
   */
  pageSize = protoInt64.zero

  /**
   * @generated from field: int64 page_num = 13;
   */
  pageNum = protoInt64.zero

  constructor(data?: PartialMessage<TopRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'product', kind: 'enum', T: proto3.getEnumType(Product) },
    { no: 2, name: 'event_type', kind: 'enum', T: proto3.getEnumType(EventType), repeated: true },
    { no: 3, name: 'start_date', kind: 'message', T: Timestamp },
    { no: 4, name: 'end_date', kind: 'message', T: Timestamp },
    { no: 5, name: 'timezone', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'all_assets', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: 'team_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: 'asset_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: 'page_id', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'directory_id', kind: 'scalar', T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 11, name: 'tag_name', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: 'page_size', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: 'page_num', kind: 'scalar', T: 3 /* ScalarType.INT64 */ }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopRequest {
    return new TopRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopRequest {
    return new TopRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopRequest {
    return new TopRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopRequest | PlainMessage<TopRequest> | undefined,
    b: TopRequest | PlainMessage<TopRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopRequest, a, b)
  }
}

/**
 * Top Codes
 *
 * @generated from message analytics.v2.TopCodesRequest
 */
export class TopCodesRequest extends Message<TopCodesRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopCodesRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopCodesRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopCodesRequest {
    return new TopCodesRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopCodesRequest {
    return new TopCodesRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopCodesRequest {
    return new TopCodesRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopCodesRequest | PlainMessage<TopCodesRequest> | undefined,
    b: TopCodesRequest | PlainMessage<TopCodesRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopCodesRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopCodesResponse
 */
export class TopCodesResponse extends Message<TopCodesResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopCodesData data = 2;
   */
  data: TopCodesData[] = []

  constructor(data?: PartialMessage<TopCodesResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopCodesResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopCodesData, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopCodesResponse {
    return new TopCodesResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopCodesResponse {
    return new TopCodesResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopCodesResponse {
    return new TopCodesResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopCodesResponse | PlainMessage<TopCodesResponse> | undefined,
    b: TopCodesResponse | PlainMessage<TopCodesResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopCodesResponse, a, b)
  }
}

/**
 * Top Destinations
 *
 * @generated from message analytics.v2.TopDestinationsRequest
 */
export class TopDestinationsRequest extends Message<TopDestinationsRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopDestinationsRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopDestinationsRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopDestinationsRequest {
    return new TopDestinationsRequest().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopDestinationsRequest {
    return new TopDestinationsRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopDestinationsRequest {
    return new TopDestinationsRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopDestinationsRequest | PlainMessage<TopDestinationsRequest> | undefined,
    b: TopDestinationsRequest | PlainMessage<TopDestinationsRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopDestinationsRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopDestinationsResponse
 */
export class TopDestinationsResponse extends Message<TopDestinationsResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopDestinationsData data = 2;
   */
  data: TopDestinationsData[] = []

  constructor(data?: PartialMessage<TopDestinationsResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopDestinationsResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopDestinationsData, repeated: true }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopDestinationsResponse {
    return new TopDestinationsResponse().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopDestinationsResponse {
    return new TopDestinationsResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopDestinationsResponse {
    return new TopDestinationsResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopDestinationsResponse | PlainMessage<TopDestinationsResponse> | undefined,
    b: TopDestinationsResponse | PlainMessage<TopDestinationsResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopDestinationsResponse, a, b)
  }
}

/**
 * Top Pages
 *
 * @generated from message analytics.v2.TopPagesRequest
 */
export class TopPagesRequest extends Message<TopPagesRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopPagesRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopPagesRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopPagesRequest {
    return new TopPagesRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopPagesRequest {
    return new TopPagesRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopPagesRequest {
    return new TopPagesRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopPagesRequest | PlainMessage<TopPagesRequest> | undefined,
    b: TopPagesRequest | PlainMessage<TopPagesRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopPagesRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopPagesResponse
 */
export class TopPagesResponse extends Message<TopPagesResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopPagesData data = 2;
   */
  data: TopPagesData[] = []

  constructor(data?: PartialMessage<TopPagesResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopPagesResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopPagesData, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopPagesResponse {
    return new TopPagesResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopPagesResponse {
    return new TopPagesResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopPagesResponse {
    return new TopPagesResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopPagesResponse | PlainMessage<TopPagesResponse> | undefined,
    b: TopPagesResponse | PlainMessage<TopPagesResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopPagesResponse, a, b)
  }
}

/**
 * Top Links
 *
 * @generated from message analytics.v2.TopLinksRequest
 */
export class TopLinksRequest extends Message<TopLinksRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopLinksRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopLinksRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopLinksRequest {
    return new TopLinksRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopLinksRequest {
    return new TopLinksRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopLinksRequest {
    return new TopLinksRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopLinksRequest | PlainMessage<TopLinksRequest> | undefined,
    b: TopLinksRequest | PlainMessage<TopLinksRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopLinksRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopLinksResponse
 */
export class TopLinksResponse extends Message<TopLinksResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopLinksData data = 2;
   */
  data: TopLinksData[] = []

  constructor(data?: PartialMessage<TopLinksResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopLinksResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopLinksData, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopLinksResponse {
    return new TopLinksResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopLinksResponse {
    return new TopLinksResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopLinksResponse {
    return new TopLinksResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopLinksResponse | PlainMessage<TopLinksResponse> | undefined,
    b: TopLinksResponse | PlainMessage<TopLinksResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopLinksResponse, a, b)
  }
}

/**
 * Top UTM Campaigns
 *
 * @generated from message analytics.v2.TopUTMCampaignsRequest
 */
export class TopUTMCampaignsRequest extends Message<TopUTMCampaignsRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopUTMCampaignsRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMCampaignsRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopUTMCampaignsRequest {
    return new TopUTMCampaignsRequest().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopUTMCampaignsRequest {
    return new TopUTMCampaignsRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMCampaignsRequest {
    return new TopUTMCampaignsRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMCampaignsRequest | PlainMessage<TopUTMCampaignsRequest> | undefined,
    b: TopUTMCampaignsRequest | PlainMessage<TopUTMCampaignsRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMCampaignsRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopUTMCampaignsResponse
 */
export class TopUTMCampaignsResponse extends Message<TopUTMCampaignsResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMCampaignsData data = 2;
   */
  data: TopUTMCampaignsData[] = []

  constructor(data?: PartialMessage<TopUTMCampaignsResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMCampaignsResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopUTMCampaignsData, repeated: true }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopUTMCampaignsResponse {
    return new TopUTMCampaignsResponse().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopUTMCampaignsResponse {
    return new TopUTMCampaignsResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMCampaignsResponse {
    return new TopUTMCampaignsResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMCampaignsResponse | PlainMessage<TopUTMCampaignsResponse> | undefined,
    b: TopUTMCampaignsResponse | PlainMessage<TopUTMCampaignsResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMCampaignsResponse, a, b)
  }
}

/**
 * Top UTM Terms
 *
 * @generated from message analytics.v2.TopUTMTermsRequest
 */
export class TopUTMTermsRequest extends Message<TopUTMTermsRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopUTMTermsRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMTermsRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopUTMTermsRequest {
    return new TopUTMTermsRequest().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopUTMTermsRequest {
    return new TopUTMTermsRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMTermsRequest {
    return new TopUTMTermsRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMTermsRequest | PlainMessage<TopUTMTermsRequest> | undefined,
    b: TopUTMTermsRequest | PlainMessage<TopUTMTermsRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMTermsRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopUTMTermsResponse
 */
export class TopUTMTermsResponse extends Message<TopUTMTermsResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMTermsData data = 2;
   */
  data: TopUTMTermsData[] = []

  constructor(data?: PartialMessage<TopUTMTermsResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMTermsResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopUTMTermsData, repeated: true }
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopUTMTermsResponse {
    return new TopUTMTermsResponse().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopUTMTermsResponse {
    return new TopUTMTermsResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMTermsResponse {
    return new TopUTMTermsResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMTermsResponse | PlainMessage<TopUTMTermsResponse> | undefined,
    b: TopUTMTermsResponse | PlainMessage<TopUTMTermsResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMTermsResponse, a, b)
  }
}

/**
 * Top UTM Referrers
 *
 * @generated from message analytics.v2.TopUTMReferrersRequest
 */
export class TopUTMReferrersRequest extends Message<TopUTMReferrersRequest> {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest

  constructor(data?: PartialMessage<TopUTMReferrersRequest>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMReferrersRequest'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'top_request', kind: 'message', T: TopRequest }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopUTMReferrersRequest {
    return new TopUTMReferrersRequest().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopUTMReferrersRequest {
    return new TopUTMReferrersRequest().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMReferrersRequest {
    return new TopUTMReferrersRequest().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMReferrersRequest | PlainMessage<TopUTMReferrersRequest> | undefined,
    b: TopUTMReferrersRequest | PlainMessage<TopUTMReferrersRequest> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMReferrersRequest, a, b)
  }
}

/**
 * @generated from message analytics.v2.TopUTMReferrersResponse
 */
export class TopUTMReferrersResponse extends Message<TopUTMReferrersResponse> {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMReferrersData data = 2;
   */
  data: TopUTMReferrersData[] = []

  constructor(data?: PartialMessage<TopUTMReferrersResponse>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'analytics.v2.TopUTMReferrersResponse'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'pagination', kind: 'message', T: Pagination },
    { no: 2, name: 'data', kind: 'message', T: TopUTMReferrersData, repeated: true }
  ])

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>
  ): TopUTMReferrersResponse {
    return new TopUTMReferrersResponse().fromBinary(bytes, options)
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>
  ): TopUTMReferrersResponse {
    return new TopUTMReferrersResponse().fromJson(jsonValue, options)
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>
  ): TopUTMReferrersResponse {
    return new TopUTMReferrersResponse().fromJsonString(jsonString, options)
  }

  static equals(
    a: TopUTMReferrersResponse | PlainMessage<TopUTMReferrersResponse> | undefined,
    b: TopUTMReferrersResponse | PlainMessage<TopUTMReferrersResponse> | undefined
  ): boolean {
    return proto3.util.equals(TopUTMReferrersResponse, a, b)
  }
}
